import React, { useEffect, useRef, useState } from "react";
import "../styles/countsection.css"

const AnimatedCounter = ({ end, suffix = "" }) => {
  const [count, setCount] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
        }
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [hasStarted]);

  useEffect(() => {
    if (!hasStarted) return;

    const endValue = parseInt(end.replace(/,/g, ""));
    const duration = 2000;
    const startTime = Date.now();

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 3);

      setCount(Math.floor(easeOut * endValue));

      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [hasStarted, end]);

  return (
    <span ref={ref}>
      {count.toLocaleString()}
      {suffix}
    </span>
  );
};

export const CountSection = () => {
  const milestones = [
    { number: "50", suffix: "+", label: "Years of Collective Expertise" },
    { number: "15", suffix: "+", label: "Delivered Projects" },
    { number: "10", suffix: "+", label: "Cities Presences Pan India" },
  ];

  return (
    <>
      <section className="milestones-section" data-testid="v2-milestones-strip">
        <div className="container">
          <div className="milestones-grid" data-testid="v2-milestones">
            {milestones.map((item, index) => (
              <div
                key={index}
                className="milestone-item"
                data-testid={`v2-milestone-${index}`}
              >
                <div className="milestone-number">
                  <AnimatedCounter
                    end={item.number}
                    suffix={item.suffix}
                  />
                </div>

                <div className="milestone-divider" />

                <div className="milestone-label">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </>
  );
};

export default CountSection;